import { useDispatch, useSelector } from "react-redux";
import "./styles/styles.scss";
import "react-toastify/dist/ReactToastify.min.css";
import { ToastContainer } from "react-toastify";
import { SWRConfig } from "swr";
import { axiosConToken } from "./helpers/axios";
import { HelmetProvider } from "react-helmet-async";
import { ConfigProvider, Spin, theme as antdTheme } from "antd";
import { StylesContext } from "./context";
import { RouterProvider } from "react-router-dom";
import { useEffect } from "react";
import { authStartChecking } from "./actions/auth";
import { createRouter } from "./routers/createRouter";
import { StaticAntd } from "./helpers";

export const COLOR = {
  50: "#e0f1ff",
  100: "#b0d2ff",
  200: "#7fb0ff",
  300: "#4d8bff",
  400: "#1e79fe",
  500: "#076ee5",
  600: "#0062b3",
  700: "#004f81",
  800: "#003650",
  900: "#001620",
  borderColor: "#E7EAF3B2",
};

const fetcher = (url) => axiosConToken.get(url).then((res) => res.data);
const App = () => {
  const dispatch = useDispatch();
  const { mytheme } = useSelector((state) => state.ui);
  const { paths, checking } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(authStartChecking());
  }, [dispatch]);

  if (checking) return <Spin size="large" tip="Cargando..." fullscreen />;

  return (
    <HelmetProvider>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: COLOR["500"],
            borderRadius: 6,
            fontFamily: "Lato, sans-serif",
          },
          components: {
            Breadcrumb: {
              // linkColor: 'rgba(0,0,0,.8)',
              // itemColor: 'rgba(0,0,0,.8)',
            },
            Button: {
              colorLink: COLOR["500"],
              colorLinkActive: COLOR["700"],
              colorLinkHover: COLOR["300"],
            },
            Calendar: {
              colorBgContainer: "none",
            },
            Card: {
              colorBorderSecondary: COLOR["borderColor"],
            },
            Carousel: {
              colorBgContainer: COLOR["800"],
              dotWidth: 8,
            },
            Rate: {
              colorFillContent: COLOR["100"],
              colorText: COLOR["600"],
            },
            Segmented: {
              colorBgLayout: COLOR["100"],
              borderRadius: 6,
              colorTextLabel: "#000000",
            },
            Table: {
              borderColor: COLOR["100"],
              colorBgContainer: "none",
              headerBg: "none",
              rowHoverBg: COLOR["50"],
            },
            Tabs: {
              colorBorderSecondary: COLOR["100"],
            },
            Timeline: {
              dotBg: "none",
            },
            Typography: {
              colorLink: COLOR["500"],
              colorLinkActive: COLOR["700"],
              colorLinkHover: COLOR["300"],
              linkHoverDecoration: "underline",
            },
          },
          algorithm:
            mytheme === "dark"
              ? antdTheme.darkAlgorithm
              : antdTheme.defaultAlgorithm,
        }}
      >
        <StylesContext.Provider
          value={{
            rowProps: {
              gutter: [
                { xs: 8, sm: 16, md: 24, lg: 32 },
                { xs: 8, sm: 16, md: 24, lg: 32 },
              ],
            },
            carouselProps: {
              autoplay: true,
              dots: true,
              dotPosition: "bottom",
              infinite: true,
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          }}
        >
          <SWRConfig value={{ fetcher }}>
            <div>
              <StaticAntd />
              <ToastContainer position="top-center" />
              <RouterProvider
                router={createRouter(paths?.routers || [])}
                future={{
                  v7_startTransition: true,
                }}
              />
            </div>
          </SWRConfig>
        </StylesContext.Provider>
      </ConfigProvider>
    </HelmetProvider>
  );
};

export default App;
